module.exports = __webpack_public_path__ + "img/appStore.5169b377.png";